import styled, { keyframes } from "styled-components";
import { colors } from "../../../../styles/colors";

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const SkeletonContainer = styled.div`
  background-color: ${colors.lightGray};
  border-radius: 9px;
  padding: 20px;
  position: relative;
  animation: ${fadeIn} 0.6s ease-out;
`;

export const SkeletonIcon = styled.div`
  width: 15px;
  height: 15px;
  background: linear-gradient(
    90deg,
    ${colors.lightGray} 25%,
    ${colors.blueGray}20 50%,
    ${colors.lightGray} 75%
  );
  background-size: 200px 100%;
  animation: ${shimmer} 1.5s infinite;
  border-radius: 2px;
  margin-right: auto;
  margin-bottom: 10px;
  display: block;
`;

export const SkeletonItem = styled.div<{ $delay: number }>`
  position: relative;
  direction: rtl;
  animation: ${fadeIn} 0.6s ease-out;
  animation-fill-mode: both;
  animation-delay: ${({ $delay }) => $delay}s;
  margin-bottom: 20px;
`;

export const SkeletonHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;

  .skeleton-title {
    width: 60px;
    height: 10px;
    background: linear-gradient(
      90deg,
      ${colors.lightGray} 25%,
      ${colors.blueGray}20 50%,
      ${colors.lightGray} 75%
    );
    background-size: 200px 100%;
    animation: ${shimmer} 1.5s infinite;
    border-radius: 2px;
  }

  .skeleton-value {
    width: 30px;
    height: 10px;
    background: linear-gradient(
      90deg,
      ${colors.lightGray} 25%,
      ${colors.blueGray}20 50%,
      ${colors.lightGray} 75%
    );
    background-size: 200px 100%;
    animation: ${shimmer} 1.5s infinite;
    border-radius: 2px;
  }
`;

export const SkeletonProgress = styled.div`
  width: 100%;
  height: 5px;
  background: linear-gradient(
    90deg,
    ${colors.lightGray} 25%,
    ${colors.blueGray}20 50%,
    ${colors.lightGray} 75%
  );
  background-size: 200px 100%;
  animation: ${shimmer} 1.5s infinite;
  border-radius: 25px;
  position: relative;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      90deg,
      transparent 0%,
      rgba(255, 255, 255, 0.4) 50%,
      transparent 100%
    );
    animation: ${shimmer} 1.5s infinite;
  }
`;
